/**
 * Time-of-day greeting for the dashboard. Split out from the component so the
 * hour boundaries can be tested directly, without faking a clock in jsdom.
 */
export function greetingFor(date: Date): string {
  const hour = date.getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 18) return 'Good afternoon'
  return 'Good evening'
}
